export function weeksToHours(numberOfWeeks: number) {
  return numberOfWeeks * 7 * 24
}
